import type { BadgeColor } from '@forge/common';
import type { DashboardStatus } from '@/api/dashboard';

export type BadgeType = 'success' | 'progress' | 'neutral' | 'error';

export interface StatusStyle {
  label: string;
  dotClass: string;
  ringClass: string;
  badgeColor: BadgeColor;
  badgeType: BadgeType;
}

export const statusStyles: Record<DashboardStatus, StatusStyle> = {
  done: {
    label: 'Done',
    dotClass: 'bg-green-500',
    ringClass: 'text-green-500',
    badgeColor: 'green',
    badgeType: 'success',
  },
  in_progress: {
    label: 'In progress',
    dotClass: 'bg-blue-500',
    ringClass: 'text-blue-500',
    badgeColor: 'blue',
    badgeType: 'progress',
  },
  todo: {
    label: 'Planned',
    dotClass: 'bg-gray-400',
    ringClass: 'text-gray-400',
    badgeColor: 'gray',
    badgeType: 'neutral',
  },
  blocked: {
    label: 'Blocked',
    dotClass: 'bg-red-500',
    ringClass: 'text-red-500',
    badgeColor: 'red',
    badgeType: 'error',
  },
};
